export default "__VITE_ASSET__7db9c121__"